import React from 'react'
import {
    Button,
    Card,
    CardActions,
    CardContent,
    Grid,
    Stack,
} from '@mui/material'
import { translate } from '../i18n'
import { ImageTargetViewerProps } from './ImageTargetViewer.types'
import LoadingImage from '../components/LoadingImage'

function ImageTargetViewer({
    imageTarget,
    index,
    onEdit,
    onDelete,
}: ImageTargetViewerProps) {
    return (
        <Grid item xs={12} md={6}>
            <Card>
                <CardContent sx={{ p: 0 }}>
                    <LoadingImage
                        path={imageTarget.image}
                        attrs={{ 'data-ar-content': '' }}
                    />
                </CardContent>
                <CardActions sx={{ pt: 0 }}>
                    <Stack
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        sx={{ width: '100%' }}
                    >
                        <Button
                            size="small"
                            color="inherit"
                            onClick={() => onEdit(index)}
                        >
                            {translate('buttons.edit')}
                        </Button>
                        <Button
                            size="small"
                            color="error"
                            onClick={() => onDelete(index)}
                        >
                            {translate('buttons.delete')}
                        </Button>
                    </Stack>
                </CardActions>
            </Card>
        </Grid>
    )
}

export default ImageTargetViewer
